export interface IControlCenterService {
  readonly isEnabled: boolean;
}

export enum CONTROL_CENTER_CONTAINERS_ID {
  CONTROL_CENTER_FULL_CONTAINER_ID = "FullSafeZoneContainer",
  CONTROL_CENTER_MINI_CONTAINER_ID = "MiniSafeZoneContainer"
}

export const CONTROL_CENTER_BI_EVENTS = {
  MINI_OPEN: "sz_mini_open", //01010101
  MINI_READY: "sz_mini_ready",
  MINI_CLOSE_INTERNAL: "sz_mini_close_internal",
  MINI_CLOSE_EXTERNAL: "sz_mini_close_external", //01010104
  FULL_OPEN: "sz_full_open", //01020101
  FULL_READY: "sz_full_ready",
  FULL_CLOSE_EXTERNAL: "sz_full_close_external", //01020104
  CATEGORY_MINI: "mini",
  CATEGORY_FULL: "full"
};


